// idv.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'env/environment';
import { getAuth } from 'firebase/auth';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { Observable, from, throwError } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class IdvService {
  private stripePromise: Promise<Stripe | null> = loadStripe(environment.stripePublishableKey);

  constructor(private http: HttpClient) { }

  // idv.service.ts
  // startVerification(): Observable<{ id: string }> {
  //   const auth = getAuth();
  //   const user = auth.currentUser;
  //   if (!user) return throwError(() => new Error('Not authenticated'));

  //   return from(user.getIdToken()).pipe(
  //     switchMap(idToken => {
  //       const headers = new HttpHeaders({ Authorization: `Bearer ${idToken}` });
  //       const url = `https://${environment.apiBaseURL}.cloudfunctions.net/createIdvSession`;
  //       // Expect { id, clientSecret }
  //       return this.http.post<{ id: string; clientSecret: string }>(url, {}, { headers });
  //     }),
  //     // Fire-and-forget the modal; we still return { id } immediately.
  //     // If you prefer to wait for the user to finish the modal, use Option B below.
  //     tap(({ clientSecret }) => { this.launchStripe(clientSecret).catch(console.error); }),
  //     map(({ id }) => ({ id }))
  //   );
  // }

  startVerification(): Observable<{ id: string }> {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) return throwError(() => new Error('Not authenticated'));

    return from(user.getIdToken()).pipe(
      switchMap(idToken => {
        const headers = new HttpHeaders({ Authorization: `Bearer ${idToken}` });
        const url = `https://${environment.apiBaseURL}.cloudfunctions.net/createIdvSession`;
        return this.http.post<{ id: string; clientSecret: string }>(url, {}, { headers });
      }),
      switchMap(({ id, clientSecret }) =>
        from(this.launchStripe(clientSecret)).pipe(
          // if user cancels, you can throw; otherwise pass through the id
          map(result => {
            if (result?.error) throw new Error(result.error.message || 'Verification cancelled');
            return { id };
          })
        )
      )
    );
  }

  getStatus(id: string): Observable<{ status: string }> {
    if (!id) return throwError(() => new Error('Missing session id'));
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) return throwError(() => new Error('Not authenticated'));

    const url = `https://${environment.apiBaseURL}.cloudfunctions.net/idv/status?id=${encodeURIComponent(id)}`;
    return from(user.getIdToken()).pipe(
      switchMap(idToken => {
        const headers = new HttpHeaders({ Authorization: `Bearer ${idToken}` });
        return this.http.get<{ status: string }>(url, { headers });
      })
    );
  }

  private async launchStripe(clientSecret: string) {
    const stripe = await this.stripePromise;
    if (!stripe) throw new Error('Stripe.js failed to load');
    return stripe.verifyIdentity(clientSecret);
  }

}
